import CryptoJS from "crypto-js"
import { encryptionKey } from "./encryptionKey" // Import the encryption key

/**
 * Encrypts the provided data using AES encryption with the encryption key.
 * @param {string} data The data to encrypt.
 * @returns {string} The encrypted data as a string.
 */
const encryptData = (data) => {
	try {
		// Encrypt the data using AES encryption with the encryption key
		const encryptedData = CryptoJS.AES.encrypt(data, encryptionKey).toString()
		console.log(`Data saved successfully under key: ${data}`);
		return encryptedData
	} catch (error) {
		console.error(`Failed to save data to localStorage: ${error}`)
	}
	// return encodeURIComponent(data)
}

/**
 * Decrypts the provided encrypted data using AES decryption with the encryption key.
 * @param {string} encryptedData The encrypted data to decrypt.
 * @returns {string} The decrypted data.
 */
const decryptData = (encryptedData) => {	
	// Encrypt the plain text
	const encryptedText = CryptoJS.AES.encrypt(
		encryptedData,
		encryptionKey
	).toString()
	let decryptedText = ""
	try {
		decryptedText = CryptoJS.AES.decrypt(encryptedData, encryptionKey).toString(
			CryptoJS.enc.Utf8
		)
	} catch (error) {
		decryptedText = "Decryption error: " + error.message
		console.log("decryptedText error ", decryptedText)
	}
	return decryptedText	
}

export { encryptData, decryptData }
